import {CHANGE_MOBILE_MENU, CHANGE_OPEN_SEARCH, FIX_PAGE, SHOW_GLOBAL_LOADER} from '@/store/mutation-types';

import {fixPage} from '@/helpers/variables'


const state = {
    globalLoader: false,
    fixPage: false,
    openMenu: false,
    openSearch: false,
};

const getters = {
    fixPage: state => state.fixPage,
    globalLoader: state => state.globalLoader,
    openMenu: state => state.openMenu,
    openSearch: state => state.openSearch,

    navigation() {
        return [
           
        ]
    }
};

const mutations = {
    [CHANGE_MOBILE_MENU](state, status) {
        state.openMenu = status;
        fixPage(status);
    },
    [CHANGE_OPEN_SEARCH](state, status) {
        state.openSearch = status
    },
    [SHOW_GLOBAL_LOADER](state, status) {
        state.globalLoader = status
    },
    [FIX_PAGE](state, param) {
        const tag = document.querySelector('html');
        if (param) {
            tag.classList.add('fix');
        } else {
            tag.classList.remove('fix');
        }
        state.fixPage = param
    },
};

export default {
    state,
    getters,
    mutations,
};
